<template>
  <div>
    <page-title
      heading="لیست میزها"
      subHeading="در این قسمت امکان مدیریت و ثبت میزهای مجموعه خود را دارید."
      buttonTitle="ایجاد میز"
      @onClickButton="showTablesFormPopup = true"
    />

    <vs-row v-if="tables && Array.isArray(tables) && tables.length > 0">
      <vs-col
        v-for="(table, index) in tables"
        :key="index"
        vs-sm="4"
        vs-xs="6"
        class="element-wrapper"
      >
        <!-- <div class="table-wrapper" :style="tableStyle(table)">
          <div
            v-for="(capacity, index) in Array.from(
              Array(table.capacity).keys()
            )"
            :key="index"
            class="chair"
            :style="positionStyle(table.capacity, index)"
          >
            <img :src="chairIcon" alt="chair-icon" class="chair-icon" />
          </div>
          <h2>{{ table.title }}</h2>
          <h6>{{ tableStatus(table) }}</h6>
        </div> -->
        <vx-card>
          <div slot="no-body" class="body">
            <div class="title-wrapper">
              <p>
                نام
                <strong>{{ table.title }}</strong>
              </p>
              <p>
                ظرفیت
                <strong>{{ table.capacity }} نفر</strong>
              </p>
            </div>
            <div slot="no-body" class="actions">
              <vs-button
                color="secondary"
                class="w-full"
                size="small"
                icon-pack="feather"
                icon="icon-edit"
                @click="() => handleOnEditTable(table)"
              />
              <vs-button
                color="danger"
                class="w-full"
                size="small"
                type="border"
                icon-pack="feather"
                icon="icon-trash"
                @click="() => handleOnDeleteTable(table)"
              />
            </div>
          </div>
        </vx-card>
      </vs-col>
    </vs-row>

    <div v-else>
      <h4 class="m-8">شماره میزی هنوز ثبت نشده است.</h4>
    </div>

    <vs-popup
      v-if="showTablesFormPopup"
      title="ثبت میز"
      :active.sync="showTablesFormPopup"
    >
      <tables-form
        @onTableChanged="onTableChanged"
        :selectedTable="selectedTable"
      />
    </vs-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageTitle from "../../../components/pageTitle/PageTitle.vue";
import providerApiService from "../../../services/api/ProviderApiService";
import TablesForm from "../form/Form.vue";
import chairIcon from "../../../assets/images/chair.png";

export default {
  name: "TablesList.vue",
  components: { PageTitle, TablesForm },
  data() {
    return {
      tables: [],
      showTablesFormPopup: false,
      chairIcon,
      selectedTable: null,
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  mounted() {
    this.getTablesList();
  },
  methods: {
    getTablesList() {
      this.$vs.loading();
      providerApiService
        .getProviderTablesList(this.currentProvider.id)
        .then((result) => {
          this.tables = result.data;
        })
        .finally(() => this.$vs.loading.close());
    },
    onTableChanged() {
      this.getTablesList();
      this.showTablesFormPopup = false;
    },
    handleOnEditTable(table) {
      this.showTablesFormPopup = true;
      this.selectedTable = table;
    },
    handleOnDeleteTable(table) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `حذف میز`,
        text: `آیا از حذف میز ${table.title} اطمینان دارید؟`,
        acceptText: "بلی",
        cancelText: "خیر",
        accept: () => this.deleteTable(table),
      });
    },
    deleteTable(table) {
      this.$vs.loading();
      providerApiService
        .deteleTable(this.currentProvider.id, table.id)
        .then(this.getTablesList);
    },
    positionStyle(total, index) {
      const radius = 85; // Half the width of the circle container
      const angle = (2 * Math.PI) / total; // Full circle divided by number of items
      const x = radius + radius * Math.cos(angle * index) - 25; // Adjust 15 for half width of the item
      const y = radius + radius * Math.sin(angle * index) - 25; // Adjust 15 for half height of the item

      // Chairs face towards the center
      const rotation = 90 + (360 / total) * index; // Rotate each chair to face the center

      return {
        left: `${x}px`,
        top: `${y}px`,
        transform: `translate(-50%, -50%) rotate(${rotation}deg)`,
      };
    },
    tableStyle(table) {
      let background = "#008854";
      let opacity = 1;

      if (table.isAvailable) {
        background = "#c0c9b7";
        opacity = 0.5;
      } else if (table.isOccupied) {
        background = "#cd4a39";
      } else if (table.isReserved) {
        background = "#0079e6";
      }

      return {
        background,
        opacity,
      };
    },
    tableStatus(table) {
      let text = "فعال است";

      if (table.isAvailable) {
        text = "غیرفعال";
      } else if (table.isOccupied) {
        text = "مشغول است";
      } else if (table.isReserved) {
        text = "رزرو شده";
      }

      return text;
    },
  },
};
</script>

<style scoped lang="scss">
.element-wrapper {
  margin: 4px 0;
  padding: 0 4px;

  @media screen and (min-width: 900px) {
    max-width: 200px;
  }

  p {
    flex: 1;
    font-size: 12px;
    border-right: 1px solid #23232315;
    text-align: center;
    display: flex;
    flex-direction: column;

    &:last-of-type {
      border-right: 0;
    }
  }

  strong {
    font-size: 18px;
    color: #232323;
  }

  .body {
    width: 100%;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 8px 0;
    gap: 8px;
  }

  .title-wrapper {
    display: flex;
    width: 100%;
  }

  .actions {
    display: flex;
    align-content: center;
    gap: 10px;

    button {
      font-weight: bold;
      font-size: 12px;
    }
  }

  .table-wrapper {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.1);
    margin: auto;
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.2s all ease-in-out;

    h2,
    h6 {
      color: #ffffff;
    }

    h6 {
      font-size: 12px;
    }

    .chair {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      position: absolute;
      display: grid;
      place-items: center;
      z-index: 1;
    }

    .chair-icon {
      width: 30px;
      height: 30px;
    }
  }
}
</style>
